// src/App.tsx
import "./styles.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";
import "firebaseui/dist/firebaseui.css"; // <-- Import FirebaseUI CSS here

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
console.log(`
###         ###   ###########   ###    ###  ###      ###   ###########  #############
###         ###   ###           ###   ###   ###      ###       ###           ###
###         ###   ###           ###  ###    ###      ###       ###           ###
###    #    ###   ###           ### #       ###      ###       ###           ###
###   ###   ###   ###########   #####       ###      ###       ###           ###
###  #####  ###   ###           ### ###     ###      ###       ###           ###
### ### ### ###   ###           ###   ###   ###      ###       ###           ###
######   ######   ###           ###    ###   ###    ###        ###           ###
#####     #####   ###########   ###     ###    ######      ###########       ###

WeKruit: We are hiring! Contact us!!
`);
root.render(
  <React.StrictMode>
    {/* <BrowserRouter basename="/app"> */}
    <App />
    {/* </BrowserRouter> */}
  </React.StrictMode>
);
